import { Loading, useUser } from '@cibo/profile'
import { Markdown } from '@cibo/ui'
import { Box, Grid, Stack } from '@mui/material'
import { AgreementDetailProps } from '../types'
import { useAgreement, useAgreementCopy } from '../queries'

export const SoilHealthDetail = ({
  agreementId,
  markdownOverrides,
  downloadButton,
}: AgreementDetailProps) => {
  const agreement = useAgreement(agreementId)
  const user = useUser()
  const agreementCopy = useAgreementCopy(agreementId)
  // @ts-ignore
  if (agreement.isLoading || user.isLoading) {
    return <Loading />
  }

  return (
    <>
      <Grid container>
        <Grid item md={4} xs={12}>
          <Stack spacing={2}>
            {agreementCopy && <Markdown overrides={markdownOverrides}>{agreementCopy}</Markdown>}

            <Box>{downloadButton}</Box>
          </Stack>
        </Grid>
      </Grid>
    </>
  )
}
